import { MultiSelect } from '@mantine/core';
import countries from 'country-list';
const countryOptions = countries.getData().map((data) => ({ label: data.name, value: data.code }));

const CountrySelect = ({ onChange, selected, readOnly = false }) => {
  return (
    <MultiSelect
      searchable={true}
      data={countryOptions}
      onChange={onChange}
      value={selected}
      placeholder="Select at least one country..."
      disabled={readOnly}
    />
  );
};

export default CountrySelect;
